import { Grid2, Typography } from "@mui/material";
import mission1 from "../../../ui-utils/photos/mission1.png";
import mission2 from "../../../ui-utils/photos/mission2.png";
import mission3 from "../../../ui-utils/photos/mission3.png";
import mission4 from "../../../ui-utils/photos/mission4.png";
import MissionMobileViewStyles from "./MissionMobileView.module.css";
import en from "../../../i18n/English/Aboutus/mission.json";
import hi from "../../../i18n/Hindi/Aboutus/mission.json";
import kn from "../../../i18n/Kannada/Aboutus/mission.json";
import ma from "../../../i18n/Marathi/Aboutus/mission.json";
import gu from "../../../i18n/Gujarati/Aboutus/mission.json";
import { useLanguage } from "../../../Context/LangContext";
export default function WebView() {
  const { language } = useLanguage();
  const translations = { en, hi, kn, gu, ma };
  const t = translations[language] || translations.en;
  return (
    <>
      <Grid2
        sx={{
          width: "100%",
          overflowX: "hidden",
          boxSizing: "border-box",
          background: "#FFF6EE"
        }}
      >
        <Grid2 className={MissionMobileViewStyles.miss_title_card}>
          <div className={MissionMobileViewStyles.headingContainer}>
            <div className={MissionMobileViewStyles.gradientBackground}></div>
            <h1 className={MissionMobileViewStyles.miss_title} style={{ fontWeight: 600 }}>
              {t.heading}
            </h1>
          </div>
        </Grid2>

        <Grid2 className={MissionMobileViewStyles.miss_maincard}>
          <Grid2 className={MissionMobileViewStyles.miss_outercard1}>
            <Grid2 className={MissionMobileViewStyles.img_outercard1}>
              <Grid2 className={MissionMobileViewStyles.img_card1}>
                <img src={mission1} alt="aboutus"></img>
              </Grid2>
            </Grid2>
            <Typography
              className={MissionMobileViewStyles.about_title}
              style={{ marginTop: "3%" }}
            >
              {t.missions[0].title}
            </Typography>

            <Typography className={MissionMobileViewStyles.about_info}>
              {t.missions[0].description}
            </Typography>
          </Grid2>
          <Grid2 className={MissionMobileViewStyles.miss_outercard2}>
            <Grid2 className={MissionMobileViewStyles.img_outercard1}>
              <Grid2 className={MissionMobileViewStyles.img_card2}>
                <img src={mission2} alt="aboutus2"></img>
              </Grid2>
            </Grid2>
            <Typography
              className={MissionMobileViewStyles.about_title}
              style={{ marginTop: "3%" }}
            >
              {t.missions[1].title}
            </Typography>
            <Typography className={MissionMobileViewStyles.about_info}>
              {t.missions[1].description}
            </Typography>
          </Grid2>
          <Grid2 className={MissionMobileViewStyles.miss_outercard3}>
            <Grid2 className={MissionMobileViewStyles.img_outercard1}>
              <Grid2 className={MissionMobileViewStyles.img_card3}>
                <img src={mission3} alt="aboutus3"></img>
              </Grid2>
            </Grid2>
            <Typography
              className={MissionMobileViewStyles.about_title}
              style={{ marginTop: "3%" }}
            >
              {t.missions[2].title}
            </Typography>
            <Typography className={MissionMobileViewStyles.about_info}>
              {t.missions[2].description}
            </Typography>
          </Grid2>
          <Grid2 className={MissionMobileViewStyles.miss_outercard4}>
            <Grid2 className={MissionMobileViewStyles.img_outercard1}>
              <Grid2 className={MissionMobileViewStyles.img_card4}>
                <img src={mission4} alt="aboutus4"></img>
              </Grid2>
            </Grid2>
            <Typography
              className={MissionMobileViewStyles.about_title}
              style={{ marginTop: "3%" }}
            >
              {t.missions[3].title}
            </Typography>
            <Typography className={MissionMobileViewStyles.about_info}>
              {t.missions[3].description}
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}
